module.exports = __webpack_public_path__ + "static/media/starfield.fa59f710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/starfield.png
// module id = 2485
// module chunks = 0